import OButton from 'components/reusable/OButton'
import ODateRangePicker from 'components/shared/datePicker/ODateRangePicker'
import AuthContext from 'context/AuthContext'
import dayjs from 'dayjs'
import { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { apiGet } from '../../utils/apiFetch'
import apiPath from '../../utils/pathObj'
import Pagination from '../Pagination'
import CategoryAdd from './CategoryAdd'
import CategoryEdit from './CategoryEdit'
import CategoryList from './CategoryList'
import CategoryView from './CategoryView'

const Category = () => {
  const { user, updatePageName, setLoading } = useContext(AuthContext)
  const { t } = useTranslation()
  const [page, setPage] = useState(1)
  const [page_size] = useState(10)
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })
  const [categoryList, setCategoryList] = useState([])
  const [categoryAdd, setCategoryAdd] = useState(false)
  const [categoryEdit, setCategoryEdit] = useState(false)
  const [currentItem, setCurrentItem] = useState('')
  const [categoryView, setCurrentView] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [isInitialized, setIsInitialized] = useState(false)
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('')
  const [filterData, setFilterData] = useState({
    category: '',
    searchkey: '',
    startDate: '',
    endDate: '',
    isReset: false,
    isFilter: false
  })
  const [sort, setSort] = useState({
    sort_key: 'createdAt',
    sort_type: 'desc'
  })

  const handleEdit = item => {
    setCurrentItem(item)
    setCategoryEdit(!categoryEdit)
  }

  const handleView = item => {
    setCurrentItem(item)
    setCurrentView(!categoryView)
  }

  const handleCategory = () => {
    setCategoryAdd(!categoryAdd)
  }

  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }

  const allCategory = async data => {
    setLoading(true)
    try {
      const { category, startDate, endDate, searchkey, isFilter } = filterData

      if (
        (data?.deletePage && categoryList?.length >= 1) ||
        (isFilter &&
          category &&
          data?.statusChange &&
          categoryList?.length >= 1)
      ) {
        setPage(page - 1)
        setPaginationObj({ ...paginationObj, page: page - 1 })
      }

      var payload = {
        page,
        page_size,
        status: category,
        start_date: startDate ? dayjs(startDate).format('YYYY-MM-DD') : null,
        end_date: endDate ? dayjs(endDate).format('YYYY-MM-DD') : null,
        keyword: searchkey,
        sort_key: sort.sort_key,
        sort_type: sort.sort_type
      }

      var path = apiPath.categoryList
      const result = await apiGet(path, payload)
      var response = result?.data?.results
      const resultStatus = result?.data?.success
      setCategoryList(response?.docs)
      setPaginationObj({
        ...paginationObj,
        page: resultStatus ? response.page : null,
        pageCount: resultStatus ? response.totalPages : null,
        perPageItem: resultStatus ? response?.docs.length : null,
        totalItems: resultStatus ? response.totalDocs : null
      })
      // }
    } catch (error) {
      console.log('error in get all users list==>>>>', error.message)
    }
    setLoading(false)
  }

  useEffect(() => {
    allCategory()
  }, [page, filterData, sort])

  const handleReset = () => {
    setFilterData({
      category: '',
      searchkey: '',
      startDate: '',
      endDate: '',
      isReset: true,
      isFilter: false
    })
    setPage(1)
    setSearchTerm('')
  }

  const handleDateChange = (start, end) => {
    setPage(1)
    setFilterData({
      ...filterData,
      isReset: false,
      startDate: start,
      endDate: end,
      isFilter: true
    })
  }
  const statusPage = e => {
    setFilterData({
      ...filterData,
      isReset: false,
      category: e.target.value,
      isFilter: true
    })
    setPage(1)
  }

  useEffect(() => {
    if (!isInitialized) {
      setIsInitialized(true)
    } else if (searchTerm || !filterData?.isReset) {
      setFilterData({
        ...filterData,
        isReset: false,
        searchkey: debouncedSearchTerm ? debouncedSearchTerm : '',
        isFilter: debouncedSearchTerm ? true : false
      })
      setPage(1)
    }
  }, [debouncedSearchTerm])

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm)
    }, 500)
    return () => {
      clearTimeout(timeoutId)
    }
  }, [searchTerm])

  useEffect(() => {
    updatePageName(t('NAV_CATEGORY_MANAGER'))
  }, [])

  return (
    <>
      {' '}
      <div className='bg-[#F9F9F9]'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] rounded-lg'>
            <form className='border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3 flex-wrap justify-between'>
              <div className='col-span-2 flex flex-wrap items-center mb-2 2xl:mb-0'>
                <div className='flex items-center lg:pt-0 pt-3 flex-wrap '>
                  <ODateRangePicker
                    handleDateChange={handleDateChange}
                    isReset={filterData?.isReset}
                    setIsReset={setFilterData}
                  />
                  <div className='flex items-center  ml-3 mb-3'>
                    <select
                      id=''
                      type='text '
                      name='category'
                      className='block p-2 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-black dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                      placeholder=' '
                      onChange={e => statusPage(e)}
                      value={filterData?.category}
                    >
                      <option selected value=''>
                        {t('O_ALL')}
                      </option>
                      <option value='active'>{t('O_ACTIVE')}</option>
                      <option value='inactive'>{t('O_INACTIVE')}</option>
                    </select>
                  </div>

                  <OButton
                    label={t('O_RESET')}
                    type='button'
                    onClick={() => handleReset()}
                    extraClasses='ml-3 mb-3'
                    style={{ borderRadius: '0.5rem' }}
                  />
                </div>
              </div>
              <div className='lg:pt-0 pt-2'>
                <label
                  for='default-search'
                  className='mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white'
                >
                  {t('O_SEARCH')}
                </label>
                <div className='flex'>
                  <div className='relative '>
                    <div className='absolute inset-y-0 right-0 flex items-center pl-3 mr-3 pointer-events-none'>
                      {!searchTerm ? (
                        <svg
                          aria-hidden='true'
                          className='w-4 h-4 text-[#A5A5A5] dark:text-gray-40'
                          fill='none'
                          stroke='currentColor'
                          viewBox='0 0 24 24'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            strokeWidth='2'
                            d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'
                          />
                        </svg>
                      ) : (
                        ''
                      )}
                    </div>
                    <input
                      type='search'
                      id='default-search'
                      className='block w-full p-2 outline-none text-sm text-gray-900 2xl:min-w-[200px] xl:min-w-[300px] rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                      placeholder={t('O_NAME')}
                      required
                      title=''
                      value={searchTerm}
                      onChange={e => setSearchTerm(e.target.value)}
                    />
                  </div>
                  {(user?.permission?.[4]?.add ||
                    user.permission?.length === 0) && (
                    <button
                      title={t('CATEGORY_ADD_CATEGORY')}
                      type='button'
                      className='bg-LightBlue flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue whitespace-nowrap'
                      onClick={() => handleCategory()}
                    >
                      + {t('CATEGORY_ADD_CATEGORY')}
                    </button>
                  )}
                </div>
              </div>
            </form>

            <CategoryList
              categoryList={categoryList}
              page={page}
              allCategory={allCategory}
              handleEdit={handleEdit}
              handleView={handleView}
              currentItem={currentItem}
              categoryView={categoryView}
              setSort={setSort}
              sort={sort}
              setPage={setPage}
            />
            {categoryView && (
              <CategoryView
                categoryView={categoryView}
                currentItem={currentItem}
                handleView={handleView}
              />
            )}

            {categoryEdit && (
              <CategoryEdit
                allCategory={allCategory}
                handleEdit={handleEdit}
                currentItem={currentItem}
              />
            )}

            {categoryAdd ? (
              <CategoryAdd
                categoryAdd={categoryAdd}
                allCategory={allCategory}
                handleCategory={handleCategory}
                setPage={setPage}
              />
            ) : null}
            {paginationObj?.totalItems ? (
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                page={page}
              />
            ) : null}
          </div>
        </div>
      </div>
    </>
  )
}

export default Category
